export default __webpack_public_path__ + "bbdca399559ce9157f699b9c56dc1e5f.png";